import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapSocialAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.platformConfiguration?.postSocialProviderOptionData, currentState.platformConfiguration?.postSocialProviderOptionData, {
    successEventName: "social_provider_configured_successfully",
    errorEventName: "social_provider_got_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.postSocialProvidersData, currentState.platformConfiguration?.postSocialProvidersData, {
    successEventName: "social_provider_enabled",
    errorEventName: "social_provider_got_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.getMultipleSocialProvider, currentState.platformConfiguration?.getMultipleSocialProvider, {
    successEventName: "social_provider_configured_successfully",
    errorEventName: "social_provider_got_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteMultipleSocialProvider, currentState.platformConfiguration?.deleteMultipleSocialProvider, {
    successEventName: "social_provider_disabled",
    errorEventName: "social_provider_got_error"
  })
];
